import {useState} from "react";

export default function FormControl({label, type, value, disabled, onChange, className, ref, placeholder}) {

    let [id] = useState((Math.random() + 1).toString(36).substring(7));

    return (
        <div className={className}>
            <label className="block text-sm font-medium mb-1" htmlFor={id}>{label}</label>
            <input
                id={id} className="form-input w-full" value={value} type={type}
                onChange={(e) => onChange && onChange(e)}
                disabled={disabled}
                ref={ref}
                placeholder={placeholder}
            />
        </div>
    );
}
